import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "./slices/counter";
import legalReducer from "./slices/legal";
import licenceProfileReducer from "./slices/licenceProfile";
import complianceOptionsReducer from "./slices/compliance";
import siteVisitReducer from "./slices/siteVisit";
import licenseeReturnReducer from "./slices/licenseeReturn";
import requestForInformationReducer from "./slices/requestForInformation";
import findingAndRecommendationReducer from "./slices/findingAndRecommendation";
import instructionReducer from "./slices/instruction";
import edenMessageReducer from "./slices/edenMessage";
import complianceInvestigationReducer from "./slices/complianceInvestigation";
import incidentReducer from "./slices/incident";
import complaintReducer from "./slices/complaint";
import incidentUpdateRequestReducer from "./slices/incidentUpdateRequest";
import meetingReducer from "./slices/meeting";
import nonComplianceReducer from "./slices/nonCompliance";
import actionOrInstructionReducer from "./slices/actionOrInstruction";
import epaCorrespondenceReducer from "./slices/epaCorrespondence";
import thirdPartyCorrespondenceReducer from "./slices/thirdPartyCorrespondence";
import notifierReducer from "../apps/circulareconomy/redux/slices/notifier";
import certificationOfRegistrationReducer from "../apps/circulareconomy/redux/slices/certificateOfRegistration";
import certificateOfRegistrationListReducer from "../apps/circulareconomy/redux/slices/certificateOfRegistrationList";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    legal: legalReducer,
    licenceProfileResponse: licenceProfileReducer,
    complianceOptions: complianceOptionsReducer,
    siteVisit: siteVisitReducer,
    licenseeReturn: licenseeReturnReducer,
    requestForInformation: requestForInformationReducer,
    findingAndRecommendationReducer: findingAndRecommendationReducer,
    instruction: instructionReducer,
    edenMessage: edenMessageReducer,
    complianceInvestigation: complianceInvestigationReducer,
    incident: incidentReducer,
    complaint: complaintReducer,
    incidentUpdateRequest: incidentUpdateRequestReducer,
    meeting: meetingReducer,
    nonCompliance: nonComplianceReducer,
    actionOrInstruction: actionOrInstructionReducer,
    epaCorrespondence: epaCorrespondenceReducer,
    thirdPartyCorrespondence: thirdPartyCorrespondenceReducer,
    notifierResponse: notifierReducer,
    certificateOfRegistrationResponse: certificationOfRegistrationReducer,
    certificateOfRegistrationListResponse: certificateOfRegistrationListReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
